import type { IState } from '../store';

export function abUseExperimentsSelector(state: IState): IState['abUseExperiments'] {
  return state.abUseExperiments;
}
